import Cookie from 'cookie-universal'

import { Tier, TiersService } from '@mc/api'

let tiers: Array<Tier>

export interface ProductsQueryParams {
  discountSlug?: string
  gift?: boolean
}

export const getTiersAsync = async (
  params?: ProductsQueryParams,
  refresh = false,
) => {
  if (!!tiers && !refresh) {
    return tiers
  }
  const collapsedBucket = getCollapsedPaintedDoorBucket()
  const personaBucket = getPersonaInTiersBucket()
  const pricingI18nBucket = getPricingI18nBucket()
  const pricingI18nV2Bucket = getPricingI18nV2Bucket()
  const response = await TiersService.getCurrentTierCollection({
    deep: true,
    ...params,
    ...(collapsedBucket && { collapsedBucket }),
    ...(personaBucket && { personaBucket }),
    ...(pricingI18nBucket && { pricingI18nBucket }),
    ...(pricingI18nV2Bucket && { pricingI18nV2Bucket }),
  })

  tiers = response.pricingTiers.map((tier) => ({
    ...tier,
    product: {
      ...tier.product,
      displayMonthlyPrice: tier?.product?.monetizedYearPricePerMonth,
      displayMonthlyPriceWithDiscount:
        tier?.product?.monetizedYearPricePerMonthDiscounted,
    },
  }))

  return tiers
}

// prcng-107_v1 experiment
const getCollapsedPaintedDoorBucket = () => {
  const cookies = Cookie()

  return cookies.get('collapsed_bucket') as string | undefined
}

// prcng-380_v3 experiment
const getPersonaInTiersBucket = () => {
  const cookies = Cookie()

  return cookies.get('persona_in_tiers') as string | undefined
}

// com-1475_v1 experiment
const getPricingI18nBucket = () => {
  const cookies = Cookie()

  return cookies.get('pricing_i18n') as string | undefined
}

// prcng-406_v1 experiment
const getPricingI18nV2Bucket = () => {
  const cookies = Cookie()

  return cookies.get('pricing_i18n_v2') as string | undefined
}
